import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["message_box", "form", "input", "status", "submit"];

  connect() {
    // this.scrollToBottom();
    console.log("debug 0");
  }

  scrollToBottom() {
    this.message_boxTarget.scrollTop = this.message_boxTarget.scrollHeight;
  }

  submit(event) {
    event.preventDefault();

    if (!this.inputTarget.value.trim()) return;

    console.log("debug 1");

    this.statusTarget.classList.remove("invisible");
    this.submitTarget.disabled = true;
    this.submitTarget.style.background = "#fbe137";
    this.formTarget.disabled = true;
    console.log("debug 2");

    // Submit the form using Rails UJS
    Rails.fire(this.formTarget, "submit");
  }
}
